/** Where processed game assets and Three's decoder binaries are served from. */

const base = (import.meta.env.VITE_PUBLIC_ASSET_URL ?? '/game-assets').replace(/\/+$/, '');

export function assetUrl(relative: string): string {
  return `${base}/${relative.replace(/^\/+/, '')}`;
}

/** Decoders are always app-relative (never on the asset CDN) so they share the app's origin. */
export const DECODER_BASIS = `${import.meta.env.BASE_URL}decoders/basis/`;
export const DECODER_DRACO = `${import.meta.env.BASE_URL}decoders/draco/`;
